import { render } from "./ConfigMessage.vue?vue&type=template&id=160a4d88&ts=true"
import script from "./ConfigMessage.vue?vue&type=script&lang=ts"
export * from "./ConfigMessage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__